import { d } from 'typegpu';
import type { VizMode } from '../../config/schema';

export const MAX_NEIGHBOR = 16;

export const NbParams = d.struct({
  nbMode: d.f32,
  perturb: d.f32,
  seed: d.f32,
  perturbMode: d.f32,
  K: d.f32,
  frameCounter: d.f32,
  _pad0: d.f32,
  _pad1: d.f32,
});

export function isNeighborVizMode(vm: VizMode): boolean {
  return vm === 'furthestNeighbor' || vm === 'totalNeighborDistance' || vm === 'ftle';
}

export function neighborModeNumber(vm: VizMode): number {
  switch (vm) {
    case 'furthestNeighbor': return 0;
    case 'totalNeighborDistance': return 1;
    case 'ftle': return 2;
    default: return 0;
  }
}

export function clampNeighborCount(n: number): number {
  return Math.max(1, Math.min(MAX_NEIGHBOR, Math.floor(n) || 1));
}
